import { DEFAULT_LABEL_COLOR_HEX, LEGACY_LABEL_COLOR_HEX } from './legacyColors';
import { normalizeHex6 } from './hex';

/**
 * Resolve a stored label color (legacy name or hex) to #RRGGBB.
 */
export function resolveLabelColor(input: string | null | undefined): string {
  if (!input || typeof input !== 'string') {
    return DEFAULT_LABEL_COLOR_HEX;
  }
  const trimmed = input.trim();
  const hex = normalizeHex6(trimmed);
  if (hex) {
    return hex;
  }
  const legacy = LEGACY_LABEL_COLOR_HEX[trimmed.toLowerCase()];
  if (legacy) {
    return legacy;
  }
  return DEFAULT_LABEL_COLOR_HEX;
}

/**
 * Normalize user input for persistence: prefer #RRGGBB, else resolve legacy name.
 */
export function normalizeStoredLabelColor(input: string): string {
  return normalizeHex6(input) ?? resolveLabelColor(input);
}

/**
 * True when value is a valid legacy name or #RGB / #RRGGBB hex.
 */
export function isValidLabelColor(input: string): boolean {
  if (!input || typeof input !== 'string') {
    return false;
  }
  const trimmed = input.trim();
  if (normalizeHex6(trimmed)) {
    return true;
  }
  return Object.prototype.hasOwnProperty.call(LEGACY_LABEL_COLOR_HEX, trimmed.toLowerCase());
}
